<template>
  <div id="report-device">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="3" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')" style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Xuất báo cáo'"
              class="btn-action-primary" @click="exportSubmit()">
              <i class="fa fa-download"></i>&nbsp;Xuất báo cáo
            </CButton>
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="refreshSubmit()">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader color="light">
            <i class="fa fa-desktop"></i>
            <strong> Thiết bị <span v-if="statistic && statistic.devices">({{ statistic.devices.total }})</span></strong>
          </CCardHeader>
          <CCardBody class="row" v-if="statistic && statistic.devices">
            <CCol sm="12" lg="12">
              <CRow>
                <CCol sm="2" md="3" lg="3" xl="2" class="mr-5">
                  <CCallout color="success">
                    <small class="text-muted">Đang kết nối</small>
                    &nbsp;<i style="font-size: 20px;color:#2eb85c" class="fa fa-rss"></i><br>
                    <strong class="h3">{{ statistic.devices.totalConnect || 0 }}
                      <small class="text-muted"> / {{ getPercentConnect + '%' }}</small><br>
                    </strong>
                  </CCallout>
                </CCol>
                <CCol sm="2" md="3" lg="3" xl="2" class="mr-5">
                  <CCallout color="danger">
                    <small class="text-muted">Mất kết nối</small>
                    &nbsp;<i style="font-size: 20px;color:#e55353" class="fa fa-unlink"></i><br>
                    <strong class="h3">{{ statistic.devices.totalDisconnect || 0 }}
                      <small class="text-muted"> / {{ getPercentDisConnect + '%' }}</small><br>
                    </strong>
                  </CCallout>
                </CCol>
                <CCol sm="2" md="3" lg="3" xl="2" class="mr-5">
                  <CCallout color="info">
                    <small class="text-muted">Đang phát sóng</small>
                    &nbsp;<i style="font-size: 20px;color:#39f" class="fa fa-play"></i><br>
                    <strong class="h3">{{ statistic.devices.totalActive || 0 }}
                      <small class="text-muted"> / {{ getPercentActive + '%' }}</small><br>
                    </strong>
                  </CCallout>
                </CCol>
                <CCol sm="2" md="3" lg="3" xl="2" class="mr-5">
                  <CCallout color="warning">
                    <small class="text-muted">Tạm dừng phát sóng</small>
                    &nbsp;<i style="font-size: 20px;color:#f9b115" class="fa fa-pause-circle"></i><br>
                    <strong class="h3">{{ statistic.devices.totalPause || 0 }}
                      <small class="text-muted"> / {{ getPercentPause + '%' }}</small><br>
                    </strong>
                  </CCallout>
                </CCol>
                <CCol sm="2" md="3" lg="3" xl="2">
                  <CCallout color="secondary">
                    <small class="text-muted">Không phát sóng</small>
                    &nbsp;<i style="font-size: 20px;color:#ced2d8" class="fa fa-stop-circle"></i><br>
                    <strong class="h3">{{ statistic.devices.totalInactive || 0 }}
                      <small class="text-muted"> / {{ getPercentInactive + '%' }}</small><br>
                    </strong>
                  </CCallout>
                </CCol>
              </CRow>
            </CCol>
          </CCardBody>
        </CCard>

        <CCard class="content-fade-in mt-3p5">
          <CCardBody>
            <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
              ref="mainTable">
              <template #index="{ index }">
                <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
              </template>
              <template #code="{ item }">
                <td>
                  <span :key="'code' + item.id + item.code" v-c-tooltip:hover="item.code" class="description">
                    {{ item.code }}<br />
                  </span>
                  <span :key="'type' + item.id + item.type" class="badge badge-light">
                    {{ item.type === 0 ? 'Truyền thanh cơ sở' : 'Tích hợp tự động' }}<br />
                  </span>
                </td>
              </template>
              <template #phoneNumber="{ item }">
                <td>
                  <template v-if="item.networkType === 0">
                    <span v-if="item.ipAddress != null && item.ipAddress != ''">
                      {{ item.ipAddress }}
                      <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"></i>&nbsp;
                    </span>
                    <span v-else class="badge badge-light">Chưa xác định </span>
                  </template>
                  <template v-else>
                    <span v-if="item.phoneNumber != null && item.phoneNumber != ''">
                      <span :key="'phone' + item.id + item.phoneNumber">{{
                        item.phoneNumber
                      }} </span>
                      <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"></i>&nbsp;
                      <template
                        v-if="item.numberRemainingDaysUseData && item.numberRemainingDaysUseData <= 30 && $hasAuthor('ROLE_ADMIN')">
                        <i class="fa"
                          :class="item.numberRemainingDaysUseData < 0 ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'"
                          style="font-size: 20px;"
                          :style="item.numberRemainingDaysUseData < 0 ? 'color:red' : 'color: #ff8502'"
                          :key="'phone' + item.id + item.phoneNumber"
                          v-c-tooltip:hover="item.numberRemainingDaysUseData < 0 ? 'Đã hết hạn dữ liệu DATA' : `Dữ liệu DATA còn lại ${item.numberRemainingDaysUseData.toString()} ngày`"></i>
                      </template>
                      <br />
                      <template v-if="item.connectStatus == 1">
                        <div id="bars">
                          <div class="bar"
                            :style="item.phoneSignal >= 1 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                          </div>
                          <div class="bar"
                            :style="item.phoneSignal >= 2 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                          </div>
                          <div class="bar"
                            :style="item.phoneSignal >= 3 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                          </div>
                          <div class="bar"
                            :style="item.phoneSignal >= 4 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'">
                          </div>
                        </div>
                        <span style="font-weight: 700;">{{ generatePhoneNetWork(item) }}</span>
                      </template>
                    </span>
                    <span v-else class="badge badge-light">Chưa xác định </span>
                  </template>
                </td>
              </template>
              <template #volume="{ item }">
                <td class="volume">
                  {{ item.volume + '%'}}
                </td>
              </template>
              <template #updateDate="{ item }">
                <td>
                  <div>{{ $helper.formatDate(item.updateDate) }}</div>
                </td>
              </template>
              <template #lastTimePing="{ item }">
                <td>{{ $helper.formatDate(item.lastTimePing) }}</td>
              </template>
              <template #activeStatus="{ item }">
                <td>
                  <template v-if="item.type == 1">
                    <span class="badge badge-light" v-if="item.activeStatus == 1"
                      style="display: inline-flex;align-items: center;"
                      :key="'activeStatus' + item.id + item.activeStatus">
                      <i class="fa fa-play-circle-o speaker " style="color:green"></i>
                      &nbsp;{{ item.micAvailable == true ? 'Có tín hiệu' : 'Không tín hiệu' }}
                      <span>{{ item.micAvailable == true ? '&nbsp;/&nbsp;' + item.bitrate : '' }}</span>
                    </span>
                    <span class="badge badge-light" v-if="item.activeStatus == 0"
                      style="display: inline-flex;align-items: center;">
                      <i class="fa fa-stop-circle-o speaker"></i>
                      &nbsp;Không tín hiệu
                    </span>
                    <br />
                  </template>
                  <template v-else>
                    <span class="badge badge-light" v-if="item.activeStatus == 0 || item.activeStatus == 1"
                      :key="'activeStatus' + item.id + item.activeStatus">
                      <i class="fa fa-play-circle-o speaker "
                        :style="item.activeStatus == 0 ? 'color:green' : 'color:#e39f00'"></i>
                      <span v-for="speaker in item.numberSpeakers">
                        <template v-if="item.activeStatus == 1">
                          <i :key="'speaker' + item.id + speaker.id" class="fa ml-2 speaker"
                            :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                            :style="speaker.running ? 'color:#e39f00' : ''"></i>
                        </template>
                        <template v-else="item.activeStatus == 0">
                          <i :key="'speaker' + item.id + speaker.id" class="fa ml-2 speaker"
                            :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                            :style="speaker.running ? 'color:green' : ''"></i>
                        </template>
                      </span>
                    </span>
                    <span class="badge badge-light" v-if="item.activeStatus == 2" v-c-tooltip.hover="'Không phát sóng'">
                      <i class="fa fa-stop-circle-o speaker"></i>
                      <span v-for="speaker in item.numberSpeakers">
                        <i class="fa fa-volume-off ml-2 speaker" :key="'speaker' + item.id + speaker.id"></i>
                      </span>
                    </span>
                  </template>
                </td>
              </template>
              <template #connectStatus="{ item }">
                <td>
                  <div style="display: inline-flex;width: 100%;height: 100%; align-items: center;">
                    <i v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')"
                      v-c-tooltip.hover="'Nhiệt độ: ' + `${parseInt(item.temperature)}℃`" :key="item.temperature"
                      style="font-size: 22px;font-weight: 500;"
                      :style="item.temperature < 80 ? 'color:black;' : 'color:red;'" class="mr-2 fa"
                      :class="item.temperature < 80 ? 'fa-thermometer-quarter' : 'fa-thermometer-full'"></i>
                    <div class="wattage-group" v-if="item.type == 0">
                      <template v-if="item.wattage === 1">
                        <i class="mr-2 fa fa-bolt" style="font-size: 23px;font-weight: 500;color:#2eb85c"
                          :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Công suất: Bật'"></i>
                      </template>
                      <template v-else-if="item.wattage === 0">
                        <i class="mr-2 fa fa-bolt" style="font-size: 23px;font-weight: 500;"
                          :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Công suất: Tắt'"></i>
                      </template>
                      <template v-else>
                        <i class="mr-2 fa fa-ban" style="font-size: 23px;font-weight: 500;"
                          :key="'wattage' + item.id + item.wattage" v-c-tooltip.hover="'Không xác định'"></i>
                      </template>
                    </div>
                    <div class="networkType-group">
                      <template v-if="item.networkType === 1">
                        <i class="mr-2 fa fa-wifi" style="font-size: 22px;font-weight: 500;"
                          :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Mạng không dây'"></i>
                      </template>
                      <template v-else-if="item.networkType === 0">
                        <CIcon name="cil-lan" class="mr-2" size="lg" :key="'netWorkType' + item.id + item.networkType"
                          v-c-tooltip.hover="'Mạng có dây'" />
                      </template>
                      <template v-else>
                        <i class="mr-2 fa fa-ban" style="font-size: 22px;font-weight: 500;"
                          :key="'netWorkType' + item.id + item.networkType" v-c-tooltip.hover="'Chưa xác định'"></i>
                      </template>
                    </div>
                    <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
                    <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
                  </div>

                </td>
              </template>
              <template #locationName="{ item }">
                <td>
                  <span class="badge "
                    :class="(item.locationName != null && item.locationName != '') ? 'badge-light' : 'badge-danger'">
                    {{ (item.locationName != null && item.locationName != '') ? item.locationName : 'Chưa gán' }}</span>
                </td>
              </template>
              <template #version="{ item }">
                <td>
                  <span class="badge badge-light">
                    {{ item.version }}
                  </span>
                </td>
              </template>
            </BaseTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "AudioFileList",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    BaseLoading
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: { value: false },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: '',
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: '',
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      statistic: '',
      isFirstLoad: true,
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "#", sorter: false, filter: false },
            { key: "updateDate", label: "Cập nhật cuối", _style: "width:10%" },
            // { key: "lastTimePing", label: "Kết nối cuối", _style: "width:10%" },
            { key: "code", label: "Mã thiết bị" },
            { key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;" },
            { key: "activeStatus", label: "Trạng thái hoạt động" },
            { key: "connectStatus", label: "Trạng thái kết nối" },
            { key: "volume", label: "Âm lượng", _style: "width:8%;" },
            { key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%" },
            { key: "locationName", label: "Địa bàn" },
          ],
          slots: ["index", "code", "volume", "version", "phoneNumber", "activeStatus", "temperature",
            "connectStatus", "updateDate", "locationName", "action", "lastTimePing"],
          sorter: true,
          columnFilter: false,
          clickableRows: false,
          hover: false,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          pageSize: 20,
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
          // lazyLoad: false
        },
        dataSource: {
          url: "/report/device",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            that.statistic = dataResponse.data;
            return dataResponse.data.devicesDetail;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    refreshSubmit() {
      this.loadDataMainTable(true);
    },
    exportSubmit() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/exports/devices",
        dataSubmit: function () {
          return that.$helper.setupDataSubmit(that.$data);
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
          } else {
            that.$helper.fetchAndDownloadByURI(response.data.data.path, response.data.data.name);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    generatePhoneNetWork(item) {
      var res = '';
      var phoneNetwork = item.phoneNetworkMode.toString();
      if (item && phoneNetwork) {
        // var network = phoneNetwork.split(".");
        switch (phoneNetwork) {
          case "0": {
            // res = 'NO SERVICE';
            res = '';
            break;
          }
          case "1": {
            res = 'GSM';
            break;
          }
          case "2": {
            res = 'G';
            break;
          }
          case "3": {
            res = 'E';
            break;
          }
          case "4": {
            res = '3G';
            break;
          }
          case "5": {
            res = '3G+';
            break;
          }
          case "6": {
            res = 'H';
            break;
          }
          case "7": {
            res = 'H+';
            break;
          }
          case "8": {
            res = 'LTE';
            break;
          }
        }
      }
      return res;
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = ''
      this.locationCode.data.model = this.districtCodeInput.data.model;
      // if (!this.isFirstLoad) {
      this.loadDataMainTable();
      // }
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      // if (!this.isFirstLoad) {
      this.loadDataMainTable();
      // }
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentConnect() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalConnect != null ? (this.statistic.devices.totalConnect / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentDisConnect() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalDisconnect != null ? (this.statistic.devices.totalDisconnect / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentActive() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalActive != null ? (this.statistic.devices.totalActive / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentInactive() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalInactive != null ? (this.statistic.devices.totalInactive / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentPause() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalPause != null ? (this.statistic.devices.totalPause / this.statistic.devices.total * 100).toFixed(1) : 0;
      }
    },
  }
};
</script>
<style>
.progress-xs {
  height: 7px!important;
}
</style>

<style scoped>
.speaker {
  font-size: 20px;
}

.blink {
  animation: blink 1.3s infinite;
  border: 1px solid;
  border-radius: 15px;
  padding: 2px 10px;
  background: rgba(0, 128, 0, 0.56);
  color: white;
  font-weight: 600;
  font-size: 12px;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

#report-device {

  .lightbox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    padding-top: 30px;
    text-align: center;

    img {
      height: 95vh;
    }
  }

  .slider.override {
    width: 200px !important;
    ;
    max-width: 200px !important;
    ;
    //padding: 0 !important;
  }

  .range-slider-rail,
  .range-slider-fill {
    height: 6px !important;
  }

  .range-slider-fill {
    background-color: #0b98ff !important;
  }

  .range-slider-knob {
    width: 15px !important;
    height: 15px !important;
  }

  .range-slider {
    padding: unset !important;
  }

  .dropdown-volume {
    padding: unset;
    border-radius: 50px;
  }

  .dropdown-volume a:hover {
    background: none !important;
  }

  .custom-toggle-volume {
    min-width: 70px;
    display: inline-flex !important;
    justify-content: center;
  }

  .custom-toggle-volume i {
    margin-top:0px !important;
  }

  .volume .dropdown {
    display: inline-flex !important;
  }

  .action-custom {
    height: 200px;
    overflow: auto;
  }

  .group-btn-action {
    height: 35px;
    justify-content: center;
  }

  .group-btn-action:hover {
    background: unset !important;
  }

  .attachImage {
    position: relative;
    width: 100%;
    border-radius: 15px;
    cursor: pointer;
    height: 500px;
    object-fit: cover;

    &:hover {}
  }

  .editAttachImage {
    cursor: pointer;
    position: absolute;
    border: 1px solid rgba(128, 128, 128, 0.52);
    color: #c51a1a;
    font-size: 18px;
    background: white;
    top: -10px;
    right: 0px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 100%;

    &:hover {
      background: red;
      color: white;
    }
  }

  $input-file-color: grey;
  $input-file-hover-color: black;

  input[type=file] {
    outline: 0;
    opacity: 0;
    pointer-events: none;
    user-select: none;
  }

  .label {
    width: 120px;
    //height: 100%;
    border: 2px dashed $input-file-color;
    border-radius: 5px;
    display: block;
    padding: 1.2em;
    transition: border 300ms ease;
    cursor: pointer;
    text-align: center;

    i {
      display: block;
      font-size: 42px;
      padding-bottom: 16px;
    }

    i,
    .title {
      color: $input-file-color;
      transition: 200ms color;
    }

    &:hover {
      border: 2px solid $input-file-hover-color;

      i,
      .title {
        color: $input-file-hover-color;
      }
    }
  }


  #bars {
    position: relative;
    width: 32px;
    height: 20px;
    display: inline-flex;

    .bar {
      position: absolute;
      bottom: 0;
      width: 4px;

      &:nth-child(1) {
        height: 6px;
        left: 0px;
      }

      &:nth-child(2) {
        height: 10px;
        left: 7px;
      }

      &:nth-child(3) {
        height: 14px;
        left: 14px;
      }

      &:nth-child(4) {
        height: 18px;
        left: 21px;
      }
    }
  }
}
</style>

